import request from '@/utils/http/jyl-request'
const BASE_URL = "v1/tvh/cockpit";


//PDM各类别板材工厂用量
export function getCategorySort(param) {
    return request({
        url: `${BASE_URL}/getCategorySort`,
        method: 'post',
        data: param
    })
}

//PDM板材颜色工厂用量榜
export function getFactoryColor(param) {
    return request({
        url: `${BASE_URL}/getFactoryColor`,
        method: 'post',
        data: param
    })
}

//PDM订单产品分布数据
export function distributionData(param) {
    return request({
        url: `${BASE_URL}/distributionData`,
        method: 'post',
        data: param
    })
}

//PDM月销售数据
export function monthlySalesData(param) {
    return request({
        url: `${BASE_URL}/monthlySalesData`,
        method: 'post',
        data: param
    })
}

//PDM各厂区生产面积
export function plantArea(param) {
    return request({
        url: `${BASE_URL}/plantArea`,
        method: 'post',
        data: param
    })
}


//TQC售后出错类型
export function errorType(param) {
    return request({
        url: `${BASE_URL}/getOrderNumByErrorType`,
        method: 'post',
        data: param
    })
}


//售后出错责任
export function personType(param) {
    return request({
        url: `${BASE_URL}/getOrderNumByPersonType`,
        method: 'post',
        data: param
    })
}


//PDM出错责任榜
export function orderPerson(param) {
    return request({
        url: `${BASE_URL}/getOrderNumByPerson`,
        method: 'post',
        data: param
    })
}


//SCM采购任务动态监控
export function purchaseCount(param) {
    return request({
        url: `${BASE_URL}/getPurchaseCount`,
        method: 'post',
        data: param
    })
}


//SCM供应商出错情况数据
export function supplierError(param) {
    return request({
        url: `${BASE_URL}/getOrderNumBySupplierError`,
        method: 'post',
        data: param
    })
}

//ASP计划排产数据
export function planData() {
    return request({
        url: `${BASE_URL}/planData`,
        method: 'get'
    })
}

//ASP排产池实时监测
export function schedulingPool() {
    return request({
        url: `${BASE_URL}/schedulingPool`,
        method: 'get'
    })
}


//ASP排产监测
export function planArea() {
    return request({
        url: `${BASE_URL}/planArea`,
        method: 'get'
    })
}
